import { EnumSubscriptionModule } from './module.constants';


/** Combined personal-token and OAuth connection allowances per account. */
export const MCP_CONNECTION_LIMITS = {
	default: 1,
	proAndAbove: 2
} as const;

/** Research Pro, Keywords Pro, Upload Pro and bundles containing these modules. */
export const MCP_PRO_MODULES: readonly EnumSubscriptionModule[] = [
	EnumSubscriptionModule.KeywordPro,
	EnumSubscriptionModule.UploadPodPro
];
